import "./Expertise.module.css";
import Header from "@/reusable_sections/Header";
import SpecializedSolutions from "./sections/SpecializedSolutions";
import CommercialExcellence from "./sections/CommercialExcellence";
import Footer from "@/reusable_sections/Footer";
export default function ExpertisePage() {
  return <div>
      <Header />
      <SpecializedSolutions />
      <CommercialExcellence />
      <Footer />
    </div>;
}